export interface IRootDomain {
  id: string;
  href: string;
  name: string;
  use_root_domain_cookie: boolean;
  created_at: string;
  updated_at: string;
}

class RootDomain {
  public readonly id: string;
  public readonly href: string;
  public readonly name: string;
  public readonly useRootDomainCookie: boolean;
  public readonly createdAt: string;
  public readonly updatedAt: string;

  constructor({
    id,
    href,
    name,
    useRootDomainCookie,
    createdAt,
    updatedAt,
  }: {
    id: string;
    href: string;
    name: string;
    useRootDomainCookie: boolean;
    createdAt: string;
    updatedAt: string;
  }) {
    this.id = id;
    this.href = href;
    this.name = name;
    this.useRootDomainCookie = useRootDomainCookie;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  public toJSON = () => ({
    id: this.id,
    href: this.href,
    name: this.name,
    useRootDomainCookie: this.useRootDomainCookie,
    createdAt: this.createdAt,
    updatedAt: this.updatedAt,
  });

  public static fromJSON = (json: IRootDomain): RootDomain => {
    const {
      id,
      href,
      name,
      use_root_domain_cookie: useRootDomainCookie,
      created_at: createdAt,
      updated_at: updatedAt,
    } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof href !== 'string') throw new Error('.href must be a string');
    if (typeof name !== 'string') throw new Error('.name must be a string');
    if (typeof useRootDomainCookie !== 'boolean') throw new Error('.useRootDomainCookie must be a boolean');
    if (typeof createdAt !== 'string') throw new Error('.createdAt must be a string');
    if (typeof updatedAt !== 'string') throw new Error('.updatedAt must be a string');

    return new RootDomain({
      id,
      href,
      name,
      useRootDomainCookie,
      createdAt,
      updatedAt,
    });
  };
}

export default RootDomain;
